import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function ProductLineupSection() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* セクションタイトル */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <span className="text-sm font-medium tracking-wider text-[#8B6BAE] uppercase mb-4 block">
            Product Lineup
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2C2C2C] mb-6 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            製品<span className="text-[#8B6BAE]">ラインナップ</span>
          </h2>
          <p className="text-lg text-[#6B6B6B] max-w-2xl mx-auto">
            描く人のために設計された、唯一のモバイルiPadケーススタンド。洗練されたデザインと機能性をご紹介します。
          </p>
        </motion.div>

        {/* カラーバリエーション */}
        <div className="mb-32">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-center mb-12"
          >
            <h3 className="text-2xl md:text-3xl font-light text-[#2C2C2C] mb-4">
              あなたのスタイルに合わせた
              <br />
              <span className="font-medium">8つのカラーバリエーション</span>
            </h3>
            <p className="text-[#6B6B6B] text-base max-w-2xl mx-auto leading-relaxed">
              洗練されたデザインと機能性を兼ね備えた全8色。
              <br className="hidden md:block" />
              ライトトーンからスモーキーなダークトーンまで、あらゆるシーンに調和します。
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.98 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1, delay: 0.2 }}
            className="relative"
          >
            <div className="block group">
              <div className="relative overflow-hidden rounded-2xl shadow-2xl shadow-stone-200/50">
                <img
                  src="https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/a6b2f3ef1ea5e0128611703d00b3edf4.jpeg"
                  alt="MOFT iPadケース 全8色のカラーバリエーション"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/10 via-transparent to-transparent pointer-events-none" />
              </div>
            </div>
          </motion.div>

          {/* 詳細ページへのボタン */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="text-center mt-8"
          >
            <a 
              href="https://lin.ee/d6PoCFQ6"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="group relative inline-flex items-center gap-2.5 px-10 py-4 bg-[#06C755] text-white rounded-full text-base font-bold hover:bg-[#05B34C] transition-all duration-300 hover:scale-[1.03] shadow-[0_4px_20px_rgba(6,199,85,0.35)] hover:shadow-[0_6px_28px_rgba(6,199,85,0.5)] cursor-pointer whitespace-nowrap"
            >
              <svg className="w-5 h-5 flex-shrink-0 transition-transform duration-300 group-hover:scale-110" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63h2.386c.346 0 .627.285.627.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596-.064.021-.133.031-.199.031-.211 0-.391-.09-.51-.25l-2.443-3.317v2.94c0 .344-.279.629-.631.629-.346 0-.626-.285-.626-.629V8.108c0-.345.282-.63.63-.63h2.386c.346 0 .627.285.627.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .344-.282.629-.631.629-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63.346 0 .628.285.628.63v4.771zm-5.741 0c0 .344-.282.629-.631.629-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63.346 0 .628.285.628.63v4.771zm-2.466.629H4.917c-.345 0-.63-.285-.63-.629V8.108c0-.345.285-.63.63-.63.348 0 .63.285.63.63v4.141h1.756c.348 0 .629.283.629.63 0 .344-.282.629-.629.629M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.258 1.058.59.12.301.079.766.038 1.08l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.078 9.436-6.975C23.176 14.393 24 12.458 24 10.314" />
              </svg>
              Makuake優先案内を受取る
              <i className="ri-arrow-right-line text-lg transition-transform duration-300 group-hover:translate-x-1"></i>
            </a>
          </motion.div>
        </div>

        {/* ペンホルダー */}
        <div>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center"
          >
            {/* 左側テキストエリア */}
            <div>
              <span className="text-sm font-medium tracking-wider text-[#8B6BAE] uppercase mb-4 block">
                Pencil Holder
              </span>
              <h3 className="text-3xl md:text-4xl font-light text-[#2C2C2C] mb-6 leading-tight">
                Apple Pencilと<span className="font-medium text-[#8B6BAE]">共に</span>
              </h3>
              <p className="text-lg text-[#6B6B6B] leading-relaxed mb-10">
                創作の相棒を、いつも手の届く場所に。
                <br />
                専用設計のペンホルダーが、あなたの集中を守ります。
              </p>
              <ul className="space-y-6 mb-10">
                <li className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 bg-white border border-[#E5E5E5] rounded-lg shadow-sm">
                    <i className="ri-pencil-line text-lg text-[#8B6BAE]"></i>
                  </div>
                  <div>
                    <h4 className="text-base font-medium text-[#2C2C2C] mb-1">専用ペンホルダー付属</h4>
                    <p className="text-sm text-[#6B6B6B]">Apple Pencilを安全に収納できる専用スロット</p>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 bg-white border border-[#E5E5E5] rounded-lg shadow-sm">
                    <i className="ri-hand-heart-line text-lg text-[#8B6BAE]"></i>
                  </div>
                  <div>
                    <h4 className="text-base font-medium text-[#2C2C2C] mb-1">描画の邪魔にならない配置</h4>
                    <p className="text-sm text-[#6B6B6B]">作業中も快適な、計算された位置設計</p>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 bg-white border border-[#E5E5E5] rounded-lg shadow-sm">
                    <i className="ri-luggage-cart-line text-lg text-[#8B6BAE]"></i>
                  </div>
                  <div>
                    <h4 className="text-base font-medium text-[#2C2C2C] mb-1">持ち運び時も一体管理</h4>
                    <p className="text-sm text-[#6B6B6B]">iPadとペンシルを一緒に、スマートに携帯</p>
                  </div>
                </li>
              </ul>
              <div className="pl-6 border-l-2 border-[#8B6BAE]">
                <p className="text-base text-[#6B6B6B] italic">
                  「集中を切らさない」ための、
                  <br />
                  細部まで考え抜かれた設計です。
                </p>
              </div>
            </div>

            {/* 右側ビジュアルエリア */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="bg-[#FAFAFA] rounded-2xl p-8 border border-[#E5E5E5]"
            >
              <div className="w-full h-[500px] flex items-center justify-center bg-white rounded-xl overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/b4ee718e6de46bd9f43dd66079299cca.jpeg"
                  alt="Apple Pencilホルダー"
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="mt-6 text-center">
                <p className="text-sm font-medium text-[#8B6BAE]">Always Ready to Create</p>
              </div>
            </motion.div>
          </motion.div>
        </div>

        {/* ペンホルダー詳細 */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mt-20"
        >
          {/* 見出し */}
          <div className="text-center mb-12">
            <p className="text-base text-[#6B6B6B] font-light max-w-lg mx-auto">
              揺れない・落ちない・充電できる。<br />
              三拍子揃った収納設計で、Apple Pencilを常にベストな状態に。
            </p>
          </div>

          {/* メインビジュアル — 2カラム */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 mb-12">
            {/* 画像エリア */}
            <div className="group relative rounded-2xl overflow-hidden border border-[#E8E8E8]">
              <img 
                src="https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/adbcc2da5fe59930791fdc756985d63f.jpeg" 
                alt="ペンホルダーカラーバリエーション" 
                className="w-full h-[340px] object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white/90 backdrop-blur-sm rounded-full text-xs font-medium text-[#2C2C2C]">
                  <i className="ri-palette-line text-[#8B6BAE]"></i>
                  全13色のカラーバリエーション
                </span>
              </div>
            </div>
            
            {/* YouTube動画エリア */}
            <div className="relative rounded-2xl overflow-hidden border border-[#E8E8E8] bg-[#1a1a1a]">
              <iframe
                className="w-full h-[340px]"
                src="https://www.youtube.com/embed/psHmdDgk0rU"
                title="ペンホルダー紹介動画"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div>
          </div>

          {/* 特徴 — 横並びストリップ */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10">
            {/* 付属品 */}
            <div className="bg-[#F8F6FA] rounded-xl p-6 border border-[#E8E8E8]">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-[#8B6BAE] rounded-lg shrink-0">
                  <i className="ri-gift-line text-base text-white"></i>
                </div>
                <div>
                  <h3 className="text-sm font-medium text-[#2C2C2C] mb-1">ケース本体に1つ付属</h3>
                  <p className="text-xs text-[#6B6B6B] leading-relaxed">
                    ケースと同色・同素材のペンホルダーが標準付属。統一感のあるデザインをそのまま。
                  </p>
                </div>
              </div>
            </div>

            {/* パーソナライズ */}
            <div className="bg-[#F8F6FA] rounded-xl p-6 border border-[#E8E8E8]">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-[#8B6BAE] rounded-lg shrink-0">
                  <i className="ri-palette-line text-base text-white"></i>
                </div>
                <div>
                  <h3 className="text-sm font-medium text-[#2C2C2C] mb-1">別売りで13色から選べる</h3>
                  <p className="text-xs text-[#6B6B6B] leading-relaxed">
                    お好きな色を追加購入可能。あなただけのカラーコーディネートでパーソナライズ。
                  </p>
                </div>
              </div>
            </div>

            {/* 充電対応 */}
            <div className="bg-[#F8F6FA] rounded-xl p-6 border border-[#E8E8E8]">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-[#8B6BAE] rounded-lg shrink-0">
                  <i className="ri-battery-charge-line text-base text-white"></i>
                </div>
                <div>
                  <h3 className="text-sm font-medium text-[#2C2C2C] mb-1">装着したまま充電</h3>
                  <p className="text-xs text-[#6B6B6B] leading-relaxed">
                    Apple Pencilを収納した状態でも充電可能。使いたい時にすぐ使える安心設計。
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 対応機種 — ミニマルバー */}
          <div className="bg-[#F8F6FA] rounded-xl px-6 py-5 border border-[#E8E8E8]">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-white rounded-lg border border-[#E8E8E8]">
                  <i className="ri-tablet-line text-sm text-[#8B6BAE]"></i>
                </div>
                <span className="text-sm font-medium text-[#2C2C2C]">対応機種</span>
              </div>
              <div className="flex flex-wrap justify-center gap-2">
                <span className="px-4 py-1.5 bg-white rounded-lg text-xs text-[#8B6BAE] font-medium border border-[#E8E8E8]">
                  iPad Air 11"
                </span>
                <span className="px-4 py-1.5 bg-white rounded-lg text-xs text-[#8B6BAE] font-medium border border-[#E8E8E8]">
                  iPad 10.9"
                </span>
                <span className="px-4 py-1.5 bg-white rounded-lg text-xs text-[#8B6BAE] font-medium border border-[#E8E8E8]">
                  iPad Mini
                </span>
              </div>
              <p className="text-xs text-[#9B9B9B]">
                ※ iPad Air 11" と iPad 10.9" は共通サイズ
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
